// Configuration for solicitor selection algorithms

export type SolicitorAlgorithm = "NearestOffice" | "ActiveNearby" | "BestPrice" | "FastestSale";

export interface SolicitorAlgorithmOption {
  value: SolicitorAlgorithm;
  name: string;
  description?: string;
}

export const SOLICITOR_ALGORITHM_OPTIONS: SolicitorAlgorithmOption[] = [
  {
    value: "ActiveNearby",
    name: "Sold nearby",
    description:
      "Here are the top 10 solicitor estate agents who have previously sold properties in your area, shown in random order.",
  },
  {
    value: "BestPrice",
    name: "Highest price",
    description:
      "These are the top 10 solicitor estate agents who achieved the highest price compared with the property's Home Report valuation, shown in random order.",
  },
  {
    value: "FastestSale",
    name: "Quickest sale",
    description:
      "These are the top 10 solicitor estate agents whose properties went under offer the quickest, shown in random order.",
  },
  {
    value: "NearestOffice",
    name: "Offices nearby",
    description:
      "Here are solicitor estate agents who have an office near your property, shown with the closest first.",
  },
];

export function getAlgorithmDisplayName(algorithm: SolicitorAlgorithm | undefined): string | null {
  if (!algorithm) return null;
  const option = SOLICITOR_ALGORITHM_OPTIONS.find((opt) => opt.value === algorithm);
  return option ? option.name : null;
}
